import axios from "axios";

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  // timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    // Get token from local storage or wherever it's stored
    const token = localStorage.getItem("auth_token");
    
    // If token exists, add to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for standard error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Log errors or handle based on status codes
    if (error.response) {
      // Server responded with an error status
      console.error("API Error Response:", error.response.status, error.response.data);
      
      // Handle 401 Unauthorized (e.g., redirect to login)
      if (error.response.status === 401) {
        // Optional: Handle unauthorized access
      }
    } else if (error.request) {
      // Request was made but no response received
      console.error("API Error Request:", error.request);
    } else {
      // Something happened in setting up the request
      console.error("API Error Setup:", error.message);
    }
    
    return Promise.reject(error);
  }
);

export default api; 